import { useAtomValue, useSetAtom } from 'jotai';
import { CheckmarkOutline, CircleDash, CloseFilled } from '@carbon/react/icons';

import {
  tcWorkspaceTasksAtom,
  tcExpandTaskPathAtom,
} from 'components/type-curve-workspace/tasks';
import { tcDetailsRightPanelAtom } from 'components/type-curve-workspace/atoms';

interface FieldVerifyIconProps {
  // Backend verification task `path` (e.g. 'vintage_date', 'formation').
  path: string;
}

export const FieldVerifyIcon = ({ path }: FieldVerifyIconProps) => {
  const { tasks } = useAtomValue(tcWorkspaceTasksAtom);
  const setExpandPath = useSetAtom(tcExpandTaskPathAtom);
  const setRightPanel = useSetAtom(tcDetailsRightPanelAtom);

  const task = tasks.find((t) => t.path === path);
  const status = task?.status ?? null;

  const handleClick = () => {
    setExpandPath(path);
    setRightPanel({ type: 'tasks', open: true });
  };

  const Icon =
    status === 'correct'
      ? CheckmarkOutline
      : status === 'incorrect'
        ? CloseFilled
        : CircleDash;

  const color =
    status === 'correct'
      ? 'var(--cds-support-02, #24a148)'
      : status === 'incorrect'
        ? 'var(--cds-support-01, #da1e28)'
        : 'var(--cds-icon-02, #525252)';

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={`Verify ${path}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '2px',
        color,
      }}
    >
      <Icon size={16} />
    </button>
  );
};
